import { Pathname } from 'history';
import { FuseNavItemType } from './types/FuseNavItemType';

/**
 * Determines whether a given URL is present in the parent's child list or not.
 */
const isUrlInChildren = (parent: FuseNavItemType, url: Pathname) => {
	if (!parent.children) {
		return false;
	}

	for (const navItem of parent.children) {
		if (navItem.children) {
			if (isUrlInChildren(navItem, url)) {
				return true;
			}
		}

		// Check for exact match or if the URL starts with the nav item URL followed by a path separator or query string
		if (navItem.url === url || url.startsWith(navItem.url + '/') || url.startsWith(navItem.url + '?')) {
			return true;
		}
	}

	return false;
};

export default isUrlInChildren;
